export enum MessageFileType {
  DOCUMENT = 'DOCUMENT',
  VOICE_MESSAGE = 'VOICE_MESSAGE',
  VIDEO = 'VIDEO'
}
